import React from "react";
import "./FAQ.css";

function FAQ() {
  return (
    <div className="faqpage-container">
      <header className="faqpage-header">
        <div className="faqpage-header-content">
          <h1>Frequently Asked Questions</h1>
          <p className="faqpage-last-updated">Last updated: February 28, 2026</p>
        </div>
      </header>

      <div className="faqpage-content">
        {/* Sidebar Navigation */}
        <aside className="faqpage-nav">
          <h3>Contents</h3>
          <ul>
            <li><a href="#how-it-works">How it Works FAQ</a></li>
            <li><a href="#platform-features">Platform Features FAQ</a></li>
            <li><a href="#learning">Learning FAQ</a></li>
            <li><a href="#ai-feedback">AI Feedback FAQ</a></li>
            <li><a href="#pricing">Pricing FAQ</a></li>
            <li><a href="#refunds">Refund FAQ</a></li>
            <li><a href="#more">And More</a></li>
          </ul>
        </aside>

        {/* Main FAQ Sections */}
        <main className="faqpage-main">
          {/* How it Works FAQ */}
          <section id="how-it-works" className="faqpage-section">
            <h2>How it Works FAQ</h2>
            <p><strong>How does the platform teach prompt engineering?</strong><br/>
              Our AI-powered platform offers interactive challenges where you write prompts, submit them for AI analysis, and receive instant feedback to improve your skills.
            </p>
            <p><strong>Is it suitable for beginners?</strong><br/>
              Yes! We offer challenges for all levels, from Beginner to Expert, with step-by-step guidance and model answers to help you learn.
            </p>
            <p><strong>How does AI improve my prompts?</strong><br/>
              The AI analyzes your prompts against best practices, suggests optimizations, and provides real-time feedback to enhance clarity and effectiveness.
            </p>
          </section>

          {/* Platform Features FAQ */}
          <section id="platform-features" className="faqpage-section">
            <h2>Platform Features FAQ</h2>
            <p><strong>Do I need to install anything?</strong><br/>
              No, our platform is entirely web-based, so you can access challenges and tools directly from your browser.
            </p>
            <p><strong>Can I import code snippets?</strong><br/>
              Yes, our one-click code import feature lets you load snippets and prompts instantly, saving you time.
            </p>
            <p><strong>Does the platform support multiple programming languages?</strong><br/>
              Yes, our challenges support popular languages like Python, JavaScript, and more, with AI guidance tailored to each.
            </p>
          </section>

          {/* Learning FAQ */}
          <section id="learning" className="faqpage-section">
            <h2>Learning FAQ</h2>
            <p><strong>How many challenges can I complete per day?</strong><br/>
              Free plan: 1/day, Starter: 10/day, Pro: 25/day, Premium: unlimited (fair-use cap of 5/hour).
            </p>
            <p><strong>What happens if I reach my challenge limit?</strong><br/>
              You'll be notified, and you can upgrade your plan to continue learning without interruption.
            </p>
            <p><strong>Can I revisit completed challenges?</strong><br/>
              Yes, you can retry challenges to refine your prompts and improve your scores.
            </p>
          </section>

          {/* AI Feedback FAQ */}
          <section id="ai-feedback" className="faqpage-section">
            <h2>AI Feedback FAQ</h2>
            <p><strong>What's included in AI feedback?</strong><br/>
              Real-time suggestions, prompt optimization tips, debugging help, coding patterns, and performance scoring compared to model answers.
            </p>
            <p><strong>Is my data secure?</strong><br/>
              Absolutely. We use encryption and secure servers, and your prompts and submissions are never shared with third parties.
            </p>
            <p><strong>Does AI replace my learning process?</strong><br/>
              No, it enhances your learning by providing guidance and feedback, allowing you to focus on mastering prompt engineering.
            </p>
          </section>

          {/* Pricing FAQ */}
          <section id="pricing" className="faqpage-section">
            <h2>Pricing FAQ</h2>
            <p><strong>Can I change plans later?</strong><br/>
              Yes, upgrades apply instantly. For downgrades, contact support.
            </p>
            <p><strong>Do you offer a free plan?</strong><br/>
              Yes, you can try the platform with limited features and 1 challenge/day.
            </p>
            <p><strong>Are there discounts for annual billing?</strong><br/>
              Yes, annual plans offer up to 20% savings compared to monthly billing.
            </p>
          </section>

          {/* Refund FAQ */}
          <section id="refunds" className="faqpage-section">
            <h2>Refund FAQ</h2>
            <p><strong>Do you offer refunds?</strong><br/>
              Yes, within 30 days of purchase — no questions asked.
            </p>
            <p><strong>How do I request a refund?</strong><br/>
              Email support@prompttar.com with your order details.
            </p>
            <p><strong>Can I pause my subscription instead?</strong><br/>
              Yes, contact us to pause or adjust your plan as needed.
            </p>
          </section>

          {/* More FAQ */}
          <section id="more" className="faqpage-section">
            <h2>And More</h2>
            <p><strong>Do you provide customer support?</strong><br/>
              Yes, via email and live chat during business hours.
            </p>
            <p><strong>Can I request new features or challenges?</strong><br/>
              Absolutely! We welcome feedback and suggestions for new challenges or features.
            </p>
            <p><strong>Where can I learn more about prompt engineering?</strong><br/>
              Explore our blog and free guides, updated weekly with tips and trends.
            </p>
          </section>
        </main>
      </div>
    </div>
  );
}

export default FAQ;